/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CheckEligibilityDetails } from './CheckEligibilityDetails';
import {
    CheckEligibilityDetailsFromJSON,
    CheckEligibilityDetailsFromJSONTyped,
    CheckEligibilityDetailsToJSON,
} from './CheckEligibilityDetails';

/**
 * 
 * @export
 * @interface CheckEligibilityResponse
 */
export interface CheckEligibilityResponse {
    /**
     * Whether the action is eligible
     * @type {boolean}
     * @memberof CheckEligibilityResponse
     */
    eligible: boolean;
    /**
     * Human-readable reason when eligible is false
     * @type {string}
     * @memberof CheckEligibilityResponse
     */
    reason?: string;
    /**
     * 
     * @type {CheckEligibilityDetails}
     * @memberof CheckEligibilityResponse
     */
    details?: CheckEligibilityDetails;
}

/**
 * Check if a given object implements the CheckEligibilityResponse interface.
 */
export function instanceOfCheckEligibilityResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "eligible" in value;

    return isInstance;
}

export function CheckEligibilityResponseFromJSON(json: any): CheckEligibilityResponse {
    return CheckEligibilityResponseFromJSONTyped(json, false);
}

export function CheckEligibilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckEligibilityResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'eligible': json['eligible'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'details': !exists(json, 'details') ? undefined : CheckEligibilityDetailsFromJSON(json['details']),
    };
}

export function CheckEligibilityResponseToJSON(value?: CheckEligibilityResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'eligible': value.eligible,
        'reason': value.reason,
        'details': CheckEligibilityDetailsToJSON(value.details),
    };
}

